<script>
    import { shipmentStore, fetchShipmentData } from "../../stores/store.js";
    import { slide, fly, fade } from "svelte/transition";
    import toast from "svelte-french-toast";
    import NavBar from "../../components/NavBar.svelte";
    import * as api from "../../utiles/api.js";
    import { onMount, onDestroy, tick } from "svelte";
    import { Preferences } from "@capacitor/preferences";
    import { push } from "svelte-spa-router";

    import ShipmentSearchSection from "./ShipmentSearchSection.svelte";
    import ShipmentListSection from "./ShipmentListSection.svelte";
    import ShipmentDetailSection from "./ShipmentDetailSection.svelte";
    import ShipmentSidePanel from "./ShipmentSidePanel.svelte";
    import LotSelectionModal from "./LotSelectionModal.svelte";

    let scrollContainer;
    let detailScrollContainer;
    let displayList = [];
    let itemsPerBatch = 20;
    let currentPage = 1;

    let isSidePanelOpen = false;
    let isLotPopupOpen = false;
    let lotDetails = [];
    let currentLoadingItem = null; // 비동기 레이스 컨디션 제어용 변수

    // 공통 코드 리스트
    let shipmntTyList = [];
    let hbrdSeList = [];
    let shipmntRegistSeList = [];
    let vatTyList = [];
    let crncyList = [];
    let shipmntSttusList = [];

    let session_empno = "";
    let session_korean_nm = "";
    let session_bplc_code = "";

    const getTodayStr = () => {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, "0");
        const d = String(now.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };

    let masterInfo = {
        shipmnt_no: "",
        shipmnt_se_code: "",
        hbrd_se_code: "",
        fctry_code: "01", // 공장코드 기본값
        shipmnt_regist_se_code: "",
        reqest_no: "",
        shipmnt_de: getTodayStr(),
        bcnc_code: "",
        bcnc_nm: "",
        vat_ty_code: "A",
        vat_rt: 10,
        splpc: 0,
        vat: 0,
        dlivy_empno: "",
        korean_nm: "",
        crncy_code: "KRW",
        ehgt: 1,
        fgcry_amount: 0,
        won_amount: 0,
        dvyfg_info_no: "",
        dvyfg_zip: "",
        dvyfg_adres_1: "",
        dvyfg_adres_2: "",
        dvyfg_adres_3: "",
        dvyfg_telno_1: "",
        dvyfg_telno_2: "",
        trnsprt_info_no: "",
        acptr_nm: "",
        rm: "",
    };

    $: totalOrderDcsn = ($shipmentStore.details || []).reduce(
        (acc, d) => acc + (Number(d.rcvord_dcsn_qy) || 0),
        0,
    );
    $: totalRequst = ($shipmentStore.details || []).reduce(
        (acc, d) => acc + (Number(d.requst_qy) || 0),
        0,
    );
    $: totalShipmntBnt = ($shipmentStore.details || []).reduce(
        (acc, d) => acc + (Number(d.shipmnt_bnt) || 0),
        0,
    );

    $: {
        displayList = $shipmentStore.list.slice(0, currentPage * itemsPerBatch);
    }

    onMount(async () => {
        const { value } = await Preferences.get({ key: "retechInfo" });
        if (value) {
            const userData = JSON.parse(value);
            session_empno = userData.login_id;
            session_korean_nm = userData.empl_nm;
            session_bplc_code = userData.bplc_code || "01";
        }

        await fetchCodeLists();
        if ($shipmentStore.list.length === 0) getData();

        window.addEventListener("popstate", handlePopState);
    });

    onDestroy(() => {
        window.removeEventListener("popstate", handlePopState);
    });

    async function fetchCodeLists() {
        try {
            const [ty, hbrd, regist, vat, crncy, sttus] = await Promise.all([
                api.get(
                    `/shipment/selectShipmntTyList?as_bplc_code=${session_bplc_code}`,
                ),
                api.get(
                    `/shipment/selectHbrdSeList?as_bplc_code=${session_bplc_code}`,
                ),
                api.get(
                    `/shipment/selectShipmntRegistSeList?as_bplc_code=${session_bplc_code}`,
                ),
                api.get(
                    `/shipment/selectVatTyList?as_bplc_code=${session_bplc_code}`,
                ),
                api.get(
                    `/shipment/selectCrncyList?as_bplc_code=${session_bplc_code}`,
                ),
                api.get(
                    `/shipment/selectShipmntSttusList?as_bplc_code=${session_bplc_code}`,
                ),
            ]);
            shipmntTyList = ty.data || [];
            hbrdSeList = hbrd.data || [];
            shipmntRegistSeList = regist.data || [];
            vatTyList = vat.data || [];
            crncyList = crncy.data || [];
            shipmntSttusList = sttus.data || [];
        } catch (e) {
            console.error("Code list fetch error:", e);
        }
    }

    async function getData() {
        await fetchShipmentData(session_bplc_code);
    }

    async function handleMasterClick(item) {
        if (scrollContainer)
            shipmentStore.update((s) => ({
                ...s,
                scrollPos: scrollContainer.scrollTop,
            }));
        currentLoadingItem = item; // 현재 요청 타겟을 기록
        shipmentStore.update((s) => ({
            ...s,
            selectedItem: item,
            isDetailLoading: true,
            details: [],
            search: { ...s.search, isExpanded: false },
        }));

        try {
            await getDetailData(item);

            const resMaster = await api.get(
                `/shipment/selectShipmentMaster?as_bplc_code=${session_bplc_code}&shipmnt_no=${item.shipmnt_no || ""}&reg_id=${session_empno}`,
            );
            if (resMaster && resMaster.data && resMaster.data.length > 0) {
                const data = Array.isArray(resMaster.data)
                    ? resMaster.data[0]
                    : resMaster.data;
                const final_empno =
                    data.dlivy_empno && data.dlivy_empno !== ""
                        ? data.dlivy_empno
                        : session_empno;
                const final_korean_nm =
                    data.korean_nm && data.korean_nm !== ""
                        ? data.korean_nm
                        : session_korean_nm;

                // 새로 생성된 출하번호만 있고 나머지가 비어있는 경우(새 객체) 처리
                if (!data.shipmnt_de) {
                    masterInfo.shipmnt_no = data.shipmnt_no || "";
                    masterInfo.shipmnt_de = getTodayStr();
                    masterInfo.dlivy_empno = final_empno;
                    masterInfo.korean_nm = final_korean_nm;
                    
                    // 💡 부모 리스트(item)의 정보를 마스터 정보 기본값으로 세팅
                    masterInfo.fctry_code = item.fctry_code || "01";
                    masterInfo.bcnc_code = item.shipmnt_bcnc_code || "";
                    masterInfo.bcnc_nm = item.bcnc_nm || "";
                    masterInfo.shipmnt_se_code = item.shipmnt_ty_code || "";
                } else {
                    masterInfo = {
                        ...masterInfo,
                        ...data,
                        shipmnt_de: data.shipmnt_de || getTodayStr(),
                        dlivy_empno: final_empno,
                        korean_nm: final_korean_nm,
                    };
                }
            } else {
                masterInfo.dlivy_empno = session_empno;
                masterInfo.korean_nm = session_korean_nm;
            }
        } catch (e) {
            masterInfo.dlivy_empno = session_empno;
            masterInfo.korean_nm = session_korean_nm;
        } finally {
            // 오직 마지막으로 호출된 아이템의 결과만 로딩 해제 처리 (레이스 컨디션 해결)
            if (currentLoadingItem === item) {
                shipmentStore.update((s) => ({
                    ...s,
                    isDetailLoading: false,
                }));
            }
        }
    }

    async function getDetailData(item) {
        try {
            const response = await api.get(
                `/shipment/detail?bplc_code=${session_bplc_code}&shipmnt_bcnc_code=${item.shipmnt_bcnc_code}&shipmnt_requst_at=${item.shipmnt_requst_at}`,
            );
            if (response.data) {
                shipmentStore.update((s) => ({
                    ...s,
                    details: response.data.map((d) => ({
                        ...d,
                        delchk: "N",
                        shipmnt_rm: "",
                        rm: d.rm || "",
                    })),
                }));
            }
        } catch (err) {
            shipmentStore.update((s) => ({ ...s, details: [] }));
        }
    }

    async function toggleRowSelection(index) {
        shipmentStore.update((s) => {
            const newDetails = [...s.details];
            const row = newDetails[index];
            row.delchk = row.delchk === "Y" ? "N" : "Y";
            if (row.delchk === "Y") {
                const stock = Number(row.nrmlt_qy || 0);
                const need = Number(row.orgn_shipmnt_bnt || row.requst_qy || 0);
                row.shipmnt_bnt = stock >= need ? need : stock;
                row.shipmnt_amount = row.shipmnt_bnt * Number(row.untpc || 0);
            } else {
                row.shipmnt_bnt = 0;
                row.shipmnt_amount = 0;
            }
            return { ...s, details: newDetails };
        });
        updateMasterTotal();
    }

    async function openLotPopup() {
        // 상세 내역에서 체크된 모든 항목들을 가져옴
        const selectedItems = $shipmentStore.details.filter(
            (d) => d.delchk === "Y",
        );

        if (selectedItems.length === 0) {
            return toast.error("상세 내역에서 품목을 먼저 선택하세요.");
        }

        isLotPopupOpen = true; // 일단 창부터 열기
    }

    // 💡 품목 그룹별로 LOT 순번(lot_sn)이 각각 1부터 증가하도록 재계산
    function recalculateLotSeqs(lots) {
        const groupCounts = {};
        return lots.map((lot) => {
            const key = `${lot.item_code}_${lot.rcvord_no || ""}_${lot.rcvord_sn || ""}`;
            if (groupCounts[key] === undefined) {
                groupCounts[key] = 1;
            } else {
                groupCounts[key] += 1;
            }
            return {
                ...lot,
                lot_sn: groupCounts[key]
            };
        });
    }

    function addSelectedLots(selectedFromModal) {
        if (!selectedFromModal || selectedFromModal.length === 0) {
            return toast.error("선택된 내역이 없거나 수량이 0입니다.");
        }

        // 1. 현재 상세내역에서 선택(체크)된 품목들의 키 목록을 생성합니다.
        const activeItemKeys = new Set(
            ($shipmentStore.details || [])
                .filter(d => d.delchk === "Y")
                .map(d => `${d.item_code}_${d.rcvord_no || ''}_${d.rcvord_sn || ''}`)
        );

        // 2. 기존 lotDetails 중에서 현재 체크된 품목이 아닌(유지되어야 하는) LOT들만 필터링합니다.
        const preservedLots = lotDetails.filter(existing => {
            const key = `${existing.item_code}_${existing.rcvord_no || ''}_${existing.rcvord_sn || ''}`;
            return !activeItemKeys.has(key);
        });

        // 3. 모달에서 선택한 모든 LOT들을 병합하여 새로운 lotDetails를 세팅합니다. (중복 LOT 등록 허용)
        const combinedLots = [
            ...preservedLots,
            ...selectedFromModal.map((s) => ({
                lot_sn: 1, // recalculateLotSeqs에서 덮어씌워짐
                lot_no: s.lot_no,
                erp_lot_no: s.erp_lot_no,
                item_code: s.item_code, // 💡 품목 코드 추가
                rcvord_no: s.rcvord_no, // 💡 수주 번호 추가 (매칭용)
                rcvord_sn: s.rcvord_sn, // 💡 수주 순번 추가 (매칭용)
                lot_se_code: s.lot_se_code, // 💡 LOT 구분 추가
                qy: s.input_qy,
                wrhous_code: s.wrhous_code,
                pda_regist_at: s.pda_regist_at || "Y", // 💡 PDA 등록 여부 추가 (기본값 Y)
                rm: "",
            })),
        ];

        // 4. 품목 그룹별로 LOT 순번을 1부터 다시 정렬하여 대입
        lotDetails = recalculateLotSeqs(combinedLots);

        isLotPopupOpen = false;
        toast.success(`${selectedFromModal.length}건 반영 완료`);
    }

    function updateMasterTotal() {
        const totalSplpc = $shipmentStore.details.reduce(
            (acc, d) => acc + (Number(d.shipmnt_amount) || 0),
            0,
        );
        masterInfo.splpc = totalSplpc;
        masterInfo.vat = Number(
            (totalSplpc * (masterInfo.vat_rt / 100 || 0.1)).toFixed(1)
        );
        masterInfo.won_amount = masterInfo.splpc + masterInfo.vat;
    }

    async function resetToMain() {
        currentLoadingItem = null; // 로딩 타겟 초기화 (진행중인 이전 요청 무효화)
        shipmentStore.update((s) => ({
            ...s,
            selectedItem: null,
            isDetailLoading: false, // 로딩 강제 종료
            detailScrollPos: 0,
        }));
        await tick();
        if (scrollContainer)
            scrollContainer.scrollTop = $shipmentStore.scrollPos;
    }

    function handleDetailScroll(e) {
        shipmentStore.update((s) => ({
            ...s,
            detailScrollPos: e.target.scrollLeft,
        }));
    }

    function handleListScroll(e) {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
            if (currentPage * itemsPerBatch < $shipmentStore.list.length) {
                currentPage++;
            }
        }
    }

    async function resetSearch() {
        const fmt = (d) => d.toISOString().split("T")[0];

        shipmentStore.set({
            list: [],
            selectedItem: null,
            details: [],
            scrollPos: 0,
            detailScrollPos: 0,
            search: {
                isExpanded: true,
                shipType: "전체",
                salesGroup: "",
                startDate: "2025-01-01",
                endDate: "2026-12-31",
                customer: "",
                orderNo: "",
                requestNo: "",
                includeComplete: false,
                includeClose: false,
            },
        });

        // 💡 사이드 패널 데이터 초기화 추가
        masterInfo = {
            shipmnt_no: "",
            shipmnt_se_code: "",
            reqest_no: "",
            shipmnt_de: getTodayStr(),
            bcnc_code: "",
            bcnc_nm: "",
            vat_ty_code: "A",
            vat_rt: 10,
            splpc: 0,
            vat: 0,
            dlivy_empno: session_empno,
            korean_nm: session_korean_nm,
            crncy_code: "KRW",
            ehgt: 1,
            fgcry_amount: 0,
            won_amount: 0,
            dvyfg_info_no: "",
            dvyfg_zip: "",
            dvyfg_adres_1: "",
            dvyfg_adres_2: "",
            dvyfg_adres_3: "",
            dvyfg_telno_1: "",
            dvyfg_telno_2: "",
            trnsprt_info_no: "",
            acptr_nm: "",
            rm: "",
        };
        lotDetails = [];
        isSidePanelOpen = false;

        await tick();
        getData();
    }

    // --- 뒤로가기 제어 로직 ---
    let sidePanelState = false;
    let lotPopupState = false;
    let detailViewState = false;
    let isProgrammaticBack = false;

    $: if (isSidePanelOpen !== sidePanelState) {
        if (isSidePanelOpen) {
            window.history.pushState({ modal: "sidePanel" }, "");
            sidePanelState = true;
        } else {
            if (
                window.history.state &&
                window.history.state.modal === "sidePanel"
            ) {
                isProgrammaticBack = true;
                window.history.back();
            }
            sidePanelState = false;
        }
    }

    $: if (isLotPopupOpen !== lotPopupState) {
        if (isLotPopupOpen) {
            window.history.pushState({ modal: "lotPopup" }, "");
            lotPopupState = true;
        } else {
            if (
                window.history.state &&
                window.history.state.modal === "lotPopup"
            ) {
                isProgrammaticBack = true;
                window.history.back();
            }
            lotPopupState = false;
        }
    }

    $: if (!!$shipmentStore.selectedItem !== detailViewState) {
        if (!!$shipmentStore.selectedItem) {
            window.history.pushState({ modal: "detailView" }, "");
            detailViewState = true;
        } else {
            if (
                window.history.state &&
                window.history.state.modal === "detailView"
            ) {
                isProgrammaticBack = true;
                window.history.back();
            }
            detailViewState = false;
        }
    }

    async function handleSaveSuccess() {
        isSidePanelOpen = false;

        // 마스터 정보 초기화 (기본값만 남기기)
        masterInfo = {
            shipmnt_no: "",
            shipmnt_se_code: "",
            hbrd_se_code: "",
            fctry_code: "01",
            shipmnt_regist_se_code: "",
            reqest_no: "",
            shipmnt_de: getTodayStr(),
            bcnc_code: "",
            bcnc_nm: "",
            vat_ty_code: "A",
            vat_rt: 10,
            splpc: 0,
            vat: 0,
            dlivy_empno: session_empno,
            korean_nm: session_korean_nm,
            crncy_code: "KRW",
            ehgt: 1,
            fgcry_amount: 0,
            won_amount: 0,
            dvyfg_info_no: "",
            dvyfg_zip: "",
            dvyfg_adres_1: "",
            dvyfg_adres_2: "",
            dvyfg_adres_3: "",
            dvyfg_telno_1: "",
            dvyfg_telno_2: "",
            trnsprt_info_no: "",
            acptr_nm: "",
            rm: "",
        };
        lotDetails = [];
        $shipmentStore.details = []; // 💡 방금 작업한 상세내역 리스트도 비워줍니다.

        // 💡 메인 리스트 최신화 (1페이지부터 다시 불러오기)
        currentPage = 1;
        await getData();
    }

    function handlePopState(e) {
        if (isProgrammaticBack) {
            isProgrammaticBack = false;
            return;
        }

        if (isLotPopupOpen) {
            isLotPopupOpen = false;
            lotPopupState = false;
        } else if (isSidePanelOpen) {
            isSidePanelOpen = false;
            sidePanelState = false;
        } else if ($shipmentStore.selectedItem) {
            resetToMain();
            detailViewState = false;
        }
    }
</script>

<div class="page-container">
    {#if $shipmentStore.isSearchLoading}
        <div class="loading-overlay">
            <div class="loading-spinner"></div>
            <p>수주 정보를 조회하는 중입니다. 잠시만 기다려주세요...</p>
        </div>
    {/if}
    <NavBar on:reset={resetSearch} />
    <div class="content-wrapper">
        {#if !$shipmentStore.selectedItem}
            <ShipmentSearchSection {getData} />
        {/if}

        <main class="main-layout">
            <ShipmentListSection
                bind:scrollContainer
                {displayList}
                {handleMasterClick}
                {resetToMain}
                {handleListScroll}
            />

            <ShipmentDetailSection
                {totalOrderDcsn}
                {totalRequst}
                {totalShipmntBnt}
                bind:isSidePanelOpen
                {toggleRowSelection}
                {updateMasterTotal}
                bind:detailScrollContainer
                {handleDetailScroll}
            />
        </main>
    </div>

    <ShipmentSidePanel
        bind:isSidePanelOpen
        bind:masterInfo
        bind:lotDetails
        details={$shipmentStore.details}
        {openLotPopup}
        {shipmntTyList}
        {hbrdSeList}
        {shipmntRegistSeList}
        {vatTyList}
        {crncyList}
        {shipmntSttusList}
        onSaveSuccess={handleSaveSuccess}
    />

    <LotSelectionModal
        bind:isLotPopupOpen
        {addSelectedLots}
        {lotDetails}
    />
</div>

<style>
    .page-container {
        display: flex;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        background: #f1f5f9;
        overflow: hidden;
    }
    .content-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .main-layout {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 10px;
        gap: 10px;
        overflow: hidden;
    }
    :global(.go2645569136) {
        font-weight: 800 !important;
    }

    /* 로딩 애니메이션 스타일 */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.75);
        backdrop-filter: blur(2px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }
    .loading-spinner {
        width: 50px;
        height: 50px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3b82f6;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 16px;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .loading-overlay p {
        font-size: 1rem;
        font-weight: 700;
        color: #1e293b;
        margin: 0;
    }
</style>
